export default __webpack_public_path__ + "static/media/image1.bdd44072.svg";